import React from "react";
import Button from "../../common/button/button";
import TableInCell from "../../common/table/tableInCell";

export function SaldosUnidadeConsumidoraMobile(props) {
    const borderColor = "#222";
    const descricaoAdicional = props.buttonWidth ? "" : "";
    const { corSaldo, corTabelaSaldo, indicadorSaldo } = props.getDadosItem(props.item);


    return (
            <div
                style={{
                    display: "flex",
                    flexDirection: props.sideTableButton ? "row-reverse" : "column",
                    alignItems: "center",
                    gap: 5,
                    padding: props.sideTableButton ? 5 : 0,
                    marginBottom: props.sideTableButton ? 5 : 0,
                    backgroundColor: props.sideTableButton ? "#008ca8" : null,
                    borderRadius: props.buttonBorderRadius || null,
                }}
            >
            {props.item.unidade_geradora || props.item.unidade_remota ? (
                <div>
                    <Button
                        style={{
                            margin: props.sideTableButton ? 0 : "5px 0px 0px 0px",
                            padding: 8,
                            width: props.buttonWidth || 100,
                            background: props.buttonBackground,
                            borderRadius: props.buttonBorderRadius || null,
                            height: "auto",
                        }}
                        type="info"
                        title="Visualizar gráfico de saldo de geração (kWh)"
                        event={() => props.setModoTela("graficoGeracaoSaldo", props.item)}
                        text={
                           
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 8,
                                    width: "100%",
                                    textAlign: "center",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: props.sideTableButton ? "1rem" : "0.8rem",
                                        display: "flex",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                        minWidth: "fit-content",
                                    }}
                                >
                                    <i className="fas fa-chart-bar mr-2"></i>
                                    Saldos
                                </div>

                                {[1, 4].includes(props.item.id_grupo_faturamento) ? (
                                    <TableInCell
                                        borderRadius={props.buttonBorderRadius || 0}
                                        backgroundColor={corTabelaSaldo}
                                        borderColor={borderColor}
                                        height={50}
                                        lista={[
                                            {
                                                cabecalho: <div style={{ color: corSaldo }}>{descricaoAdicional} P </div>,
                                                valor: (
                                                    <div style={{ color: corSaldo }}>
                                                        {props.item.unidade_geradora || props.item.unidade_remota
                                                            ? Math.round(props.item.saldo_geracao_ponta || 0)
                                                            : "-"}
                                                    </div>
                                                ),
                                            },
                                            {
                                                cabecalho: <div style={{ color: corSaldo }}>{descricaoAdicional} FP </div>,
                                                valor: (
                                                    <div style={{ color: corSaldo }}>
                                                        {props.item.unidade_geradora || props.item.unidade_remota
                                                            ? Math.round(props.item.saldo_geracao_fora_ponta || 0)
                                                            : "-"}
                                                    </div>
                                                ),
                                            },
                                            {
                                                cabecalho: <div style={{ color: corSaldo }}>{descricaoAdicional} Total </div>,
                                                valor: (
                                                    <div style={{ color: corSaldo }}>
                                                        {props.item.unidade_geradora || props.item.unidade_remota ? (
                                                            <>
                                                                <span>{Math.round(props.item.saldo_geracao || 0)}</span>
                                                                {indicadorSaldo}
                                                            </>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </div>
                                                ),
                                            },
                                        ]}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            color: corSaldo,
                                            width: "50%",
                                            minHeight: 50,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            gap: "6px",
                                            paddingRight: "10px",
                                            borderRadius: props.buttonBorderRadius || 0,
                                        }}
                                    >
                                        {props.item.unidade_geradora || props.item.unidade_remota ? (
                                            <>
                                                <span style={{fontSize: "16px", color: "#000"}}>
                                                    {descricaoAdicional ? `${descricaoAdicional}: ` : ""}
                                                    {Math.round(props.item.saldo_geracao || 0)}
                                                </span>
                                                <span style={{ marginBottom: "3px" }}>
                                                {indicadorSaldo}
                                                </span>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </div>
                                )}
                            </div>
                        }
                    />
                </div>
            ) : null}
        </div>
    );
}   